export default function CustomerTurn({ text }: { text: string }) {
  return (
    <article className="mb-8 py-4 px-6 bg-card border-l border-primary/40 rounded-r-card" aria-label="Your reply">
      <div className="text-[11px] font-semibold uppercase tracking-[0.12em] text-muted-foreground mb-2">
        You
      </div>
      <div className="text-base leading-relaxed text-foreground">
        {text.split('\n\n').map((p, i) => (
          <p key={i} className={i > 0 ? 'mt-3' : undefined}>{p}</p>
        ))}
      </div>
    </article>
  );
}
